import React, { useEffect } from "react";
import DMSHeader from "../../DMSHeader/DMSHeader";
//import DailyFloodReportCompTable from "./DailyFloodReportCompTable";
import { useTranslation } from "react-i18next";
import DailyEarthquakeReportForm from "./DailyEarthquakeReportForm";
import "../ReportEnhanced.css";

const DailyEarthquakeReport = () => {
  const { t } = useTranslation();

  return (
    <div className="report-enhanced-wrapper">
      <div className="report-header-enhanced">
        <DMSHeader title="Earthquake Daily Report" />
      </div>
      <div className="report-table-enhanced">
        <DailyEarthquakeReportForm />
      </div>
    </div>
  );
};

export default DailyEarthquakeReport;
